import { Component, Input, ViewChild, ElementRef, Output, EventEmitter, AfterViewChecked } from '@angular/core';

import { SliderUtilUpdateNavigation } from '../utils/slider.utils';

@Component({
  selector: 'mb-slider-navigation',
  templateUrl: './slider-navigation.component.html',
  styleUrls: ['./slider-navigation.component.scss'],
})
export class SliderNavigationComponent implements AfterViewChecked {
  @ViewChild('navigation', { static: true }) navigation!: ElementRef<any>;

  public items: any[] = [];

  @Input() threshhold = 2;
  private _length = 0;
  @Input()
  set length(_length: number) {
    this.items = new Array(_length || 0);
    this.updateNavigation();
  }
  get length() {
    return this._length;
  }

  private _index = 0;
  @Input()
  set activeIndex(_index: number) {
    this._index = _index;
  }
  get activeIndex() {
    return this._index;
  }

  @Output() indexChange = new EventEmitter<number>();

  updateNavigation() {
    if (this.navigation) {
      const cb = SliderUtilUpdateNavigation(this.items.length, this.threshhold, this._index);
      this.navigation.nativeElement.childNodes.forEach(cb);
    }
  }

  ngAfterViewChecked(): void {
    this.updateNavigation();
  }
}
